import type { Gender } from './domain';

export type { Gender };

export type AgeSubcategory =
  | 'MLADSI_DOROSTENEC'
  | 'STREDNI_DOROSTENEC'
  | 'STARSI_DOROSTENEC'
  | 'MLADSI_DOROSTENKA'
  | 'STREDNI_DOROSTENKA'
  | 'STARSI_DOROSTENKA'
  | 'MLADSI_ZAK'
  | 'STARSI_ZAK'
  | 'MUZ'
  | 'ZENA'
  | 'OSTATNI';

export interface IndividualEntry {
  id: number;
  categoryId: number;
  categoryName?: string;
  firstName: string;
  lastName: string;
  birthYear?: number;
  gender: Gender;
  ageSubcategory: AgeSubcategory;
  sdhUnitName: string;
  registrationNumber?: string;
  startNumber?: number;
  note?: string;
}

export interface CreateIndividualEntryRequest {
  firstName: string;
  lastName: string;
  birthYear?: number;
  gender: Gender;
  ageSubcategory: AgeSubcategory;
  sdhUnitName: string;
  registrationNumber?: string;
  startNumber?: number;
  note?: string;
}

export type UpdateIndividualEntryRequest = CreateIndividualEntryRequest;

export const AGE_SUBCATEGORY_LABELS: Record<AgeSubcategory, string> = {
  MLADSI_DOROSTENEC: 'Mladší dorostenec',
  STREDNI_DOROSTENEC: 'Střední dorostenec',
  STARSI_DOROSTENEC: 'Starší dorostenec',
  MLADSI_DOROSTENKA: 'Mladší dorostenka',
  STREDNI_DOROSTENKA: 'Střední dorostenka',
  STARSI_DOROSTENKA: 'Starší dorostenka',
  MLADSI_ZAK: 'Mladší žák',
  STARSI_ZAK: 'Starší žák',
  MUZ: 'Muž',
  ZENA: 'Žena',
  OSTATNI: 'Ostatní',
};

export const AGE_SUBCATEGORY_ORDER: AgeSubcategory[] = [
  'MLADSI_ZAK',
  'STARSI_ZAK',
  'MLADSI_DOROSTENEC',
  'STREDNI_DOROSTENEC',
  'STARSI_DOROSTENEC',
  'MLADSI_DOROSTENKA',
  'STREDNI_DOROSTENKA',
  'STARSI_DOROSTENKA',
  'MUZ',
  'ZENA',
  'OSTATNI',
];
